import { FC } from 'react';
import { nl2br } from '@edikk-edikk/br';
import classNames from 'classnames';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailCss from '../assets/advert-detail.module.scss';

const Description: FC = () => {
  const {
    advert: {
      info,
    },
  } = useAdvertDetailContext();

  if (!info) {
    return null;
  }

  return (
    <div className={classNames(advertDetailCss.advertDetail__description, advertDetailCss.advertDetail__description)}>
      {nl2br(info)}
    </div>
  );
};

export { Description };
